import { useLocation } from "react-router-dom";
import { getLocalStorageItem } from "utils/localStorage";
import { STORAGE_LANGUAGE_NAME } from "constants/variables";
import { useLocalizationStore } from "stores/localization";

interface UseLanguage {
  lang: string;
  langUrlPrefix: string;
  path: string;
}

export const useLanguage = (): UseLanguage => {
  const current =
    useLocalizationStore((s) => s.language) ||
    getLocalStorageItem(STORAGE_LANGUAGE_NAME) ||
    "en";

  const location = useLocation();
  const lang = current.toLowerCase();
  const langUrlPrefix = lang === "en" ? "" : `/${lang}`;

  const path =
    location.pathname.replace(new RegExp(`^/${lang}(?=/|$)`), "") || "/";

  return {
    lang,
    langUrlPrefix,
    path: path.toLowerCase(),
  };
};
